import { Radio, Stack } from '@mui/material';

import { PageList } from 'types/api/pageList';

export const pageLabels: {
    color: string;
    value: PageList['label'];
}[] = [
    {
        color: '#5bc5fc',
        value: 'blue',
    },
    {
        color: '#95e176',
        value: 'green',
    },
    {
        color: '#de9ce7',
        value: 'purple',
    },
    {
        color: '#f8726a',
        value: 'red',
    },
    {
        color: '#ffb254',
        value: 'yellow',
    },
];

type PageTagSelectorProps = {
    label?: PageList['label'];
    onChange?: (label: PageList['label']) => void;
};

export const PageTagSelector = ({
    label,
    onChange = () => undefined,
}: PageTagSelectorProps): JSX.Element => {
    return (
        <Stack spacing={2} direction="row" justifyContent="center">
            {pageLabels.map((el) => (
                <Radio
                    key={el.value}
                    onClick={() => {
                        if (label === el.value) {
                            onChange(undefined);
                        } else {
                            onChange(el.value);
                        }
                    }}
                    checked={label === el.value}
                    style={{
                        color: el.color,
                    }}
                />
            ))}
        </Stack>
    );
};
